export const locale = {
  'NO_PROCURATORY' : {
    'TITLE' : 'No procuratory',
    'MESSAGE' : 'There is no procuratory for this driver. Do you want to continue?',
    'CONFIRM' : 'Yes, continue',
    'DECLINE' : 'Cancel',
  },
};
